/* eslint-disable */

const path = './sport-icons/';

export default {
    american_football: require(`${path}american_football.svg`).default,
    athletics: require(`${path}athletics.svg`).default,
    australian_rules: require(`${path}australian_rules.svg`).default,
    baseball: require(`${path}baseball.svg`).default,
    basketball: require(`${path}basketball.svg`).default,
    basketball_3x3: require(`${path}basketball_3x3.svg`).default,
    beach_soccer: require(`${path}beach_soccer.svg`).default,
    beach_volleyball: require(`${path}beach_volleyball.svg`).default,
    boxing: require(`${path}boxing.svg`).default,
    cricket: require(`${path}cricket.svg`).default,
    football: require(`${path}football.svg`).default,
    futsal: require(`${path}futsal.svg`).default,
    golf: require(`${path}golf.svg`).default,
    handball: require(`${path}handball.svg`).default,
    hockey: require(`${path}hockey.svg`).default,
    ice_hockey: require(`${path}ice_hockey.svg`).default,
    mma: require(`${path}mma.svg`).default,
    motorsport: require(`${path}motorsport.svg`).default,
    snooker: require(`${path}snooker.svg`).default,
    tennis: require(`${path}tennis.svg`).default,
    volleyball: require(`${path}volleyball.svg`).default,
    badminton: require(`${path}badminton.svg`).default,
    bandy: require(`${path}bandy.svg`).default,
    biathlon: require(`${path}biathlon.svg`).default,
    chess: require(`${path}chess.svg`).default,
    curling: require(`${path}curling.svg`).default,
    darts: require(`${path}darts.svg`).default,
    formula_1: require(`${path}formula_1.svg`).default,
    rugby: require(`${path}rugby.svg`).default,
    rugby_league: require(`${path}rugby_league.svg`).default,
    table_tennis: require(`${path}table_tennis.svg`).default,
    water_polo: require(`${path}water_polo.svg`).default,
    specials: require(`${path}specials.svg`).default,
    cycling: require(`${path}cycling.svg`).default,
    alpine_skiing: require(`${path}alpine_skiing.svg`).default,
    ski_jumping: require(`${path}ski_jumping.svg`).default,
    cross_country: require(`${path}cross_country.svg`).default,
    modern_pentathlon: require(`${path}modern_pentathlon.svg`).default,
    fencing: require(`${path}fencing.svg`).default,
    trampoline_gymnastics: require(`${path}trampoline_gymnastics.svg`).default,
    sport_climbing: require(`${path}sport_climbing.svg`).default,
    shooting: require(`${path}shooting.svg`).default,
    surfing: require(`${path}surfing.svg`).default,
    synchronized_swimming: require(`${path}synchronized_swimming.svg`).default,
    triathlon: require(`${path}triathlon.svg`).default,
    rugby_sevens: require(`${path}rugby_sevens.svg`).default,
    rhythmic_gymnastics: require(`${path}rhythmic_gymnastics.svg`).default,
    archery: require(`${path}archery.svg`).default,
    weightlifting: require(`${path}weightlifting.svg`).default,
    softball: require(`${path}softball.svg`).default,
    artistic_gymnastics: require(`${path}artistic_gymnastics.svg`).default,
    skateboarding: require(`${path}skateboarding.svg`).default,
    diving: require(`${path}diving.svg`).default,
    swimming: require(`${path}swimming.svg`).default,
    sailing: require(`${path}sailing.svg`).default,
    equestrian: require(`${path}equestrian.svg`).default,
    taekwondo: require(`${path}taekwondo.svg`).default,
    karate: require(`${path}karate.svg`).default,
    judo: require(`${path}judo.svg`).default,
    canoe_sprint: require(`${path}canoe_sprint.svg`).default,
    canoeing: require(`${path}canoe_sprint.svg`).default,
    canoe_slalom: require(`${path}canoe_slalom.svg`).default,
    rowing: require(`${path}rowing.svg`).default,
    olympics: require(`${path}olympics.svg`).default,
    wrestling: require(`${path}wrestling.svg`).default,
    nascar: require(`${path}nascar.svg`).default,
    horse_racing: require(`${path}horse_racing.svg`).default,
    default: require(`${path}classic_default.svg`).default,
};
